import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, HelpCircleIcon } from 'lucide-react';
const faqs = [{
  question: '¿Realmente se hacen en 5 minutos?',
  answer: 'Sí. El tiempo de preparación activa es de 5 minutos. Esto significa que vos trabajás 5 minutos (cortar, mezclar, condimentar). Algunas recetas tienen tiempo de cocción adicional (horno, airfryer), pero vos no estás ahí parada esperando. El sistema está diseñado para liberarte.'
}, {
  question: '¿Necesito airfryer?',
  answer: 'No. Hay una sección especial de airfryer porque muchas mamás la tienen, pero la mayoría de recetas usan sartén, horno o microondas. Cocinás con lo que tengas en tu cocina hoy.'
}, {
  question: '¿Los ingredientes son fáciles de conseguir en LATAM?',
  answer: 'Sí, 100%. Todo está pensado con ingredientes comunes de supermercados latinoamericanos. Nada exótico, nada importado, nada que tengas que buscar en tiendas especializadas.'
}, {
  question: '¿Sirve para familias con niños?',
  answer: 'Absolutamente. Las recetas son simples, sabrosas y aptas para toda la familia. Varias mamás nos dicen que sus hijos las piden de nuevo porque tienen "sabor a hogar" y no son comidas "de dieta" aburridas.'
}, {
  question: '¿Qué nivel de cocina necesito?',
  answer: 'Cero. Si sabés prender una hornalla, podés hacer estas recetas. No hay técnicas complicadas, ni cortes franceses, ni pasos confusos. Es abrir, leer y hacer.'
}, {
  question: '¿Puedo imprimirlo?',
  answer: 'Sí. Es un PDF digital de alta calidad que podés imprimir en casa, leer en el celular, tablet o computadora. Es tuyo para siempre y no necesitás conexión a internet para usarlo una vez descargado.'
}, {
  question: '¿Qué pasa si no me gusta?',
  answer: 'Te devolvemos tu dinero. Sin preguntas, sin formularios complicados. Queremos que estés tranquila con tu compra y que realmente sientas el alivio en tu cocina.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-white" data-id="element-33">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-34">
        <div className="text-center mb-12" data-id="element-35">
          <div className="inline-flex items-center justify-center p-3 bg-orange-50 rounded-full text-orange-500 mb-4" data-id="element-36">
            <HelpCircleIcon className="w-6 h-6" data-id="element-37" />
          </div>
          <h2 className="text-3xl font-serif font-bold text-gray-900" data-id="element-38">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-39">
          {faqs.map((faq, index) => <div key={index} className={`border rounded-xl transition-all duration-200 ${openIndex === index ? 'border-rose-200 bg-rose-50/30 shadow-sm' : 'border-gray-100 hover:border-rose-100'}`} data-id="element-40">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-41">
                <span className={`font-bold text-lg ${openIndex === index ? 'text-rose-600' : 'text-gray-800'}`} data-id="element-42">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-rose-500 flex-shrink-0" data-id="element-43" /> : <ChevronDownIcon className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-44" />}
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-45">
                <div className="p-5 pt-0 text-gray-600 leading-relaxed" data-id="element-46">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}